/* eslint-disable no-undef */
import moment from 'moment'
import { PreviewImg } from './imagepath'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import localizedFormat from 'dayjs/plugin/localizedFormat' // For more flexible formats
import timezone from 'dayjs/plugin/timezone'
import axios from 'axios'

// Extend dayjs with UTC and localized format plugins
dayjs.extend(utc)
dayjs.extend(localizedFormat)
dayjs.extend(timezone)

export const OVERDUE = '(Overdue)'

export const amountFormat = (value) => {
  return (value || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}

export const toTitleCase = (str) => {
  if (typeof str !== 'string' || str.trim() === '') {
    return str
  }

  return str.toLowerCase().replace(/(?:^|\s)\w/g, function (match) {
    return match.toUpperCase()
  })
}

export const formattedTime = (date) => {
  return moment(date).format('h:mm A')
}

export const handleImageError = (event) => {
  event.target.src = PreviewImg
}

export const uniqueId = () => {
  var dt = new Date().getTime()
  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (dt + Math.random() * 16) % 16 | 0
    dt = Math.floor(dt / 16)
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
  })
  return uuid
}

export function debounce(func, timeout = 300) {
  let timer
  return (...args) => {
    clearTimeout(timer)
    timer = setTimeout(() => {
      func.apply(this, args)
    }, timeout)
  }
}

export const acceptExtensions = {
  'image/*': ['.png', '.jpg', '.jpeg', '.gif']
}

export const getMinDate = () => {
  const today = new Date()
  const year = today.getFullYear()
  const month = String(today.getMonth() + 1).padStart(2, '0') // Add leading zero
  const day = String(today.getDate()).padStart(2, '0') // Add leading zero
  const hours = String(today.getHours()).padStart(2, '0')
  const minutes = String(today.getMinutes()).padStart(2, '0')

  return `${year}-${month}-${day}T${hours}:${minutes}`
}

export const convertToCalenderDate = (timestamp) => {
  return dayjs.unix(timestamp).format('M/D/YYYY')
}

export const getFormattedDateFromTimestamp = (input, format = 'YYYY-MM-DDTHH:mm:ss') => {
  // Check if the input is a valid timestamp (a valid numeric value).
  const timestamp = Number(input)
  if (!isNaN(timestamp) && timestamp > 0) {
    return dayjs.unix(timestamp).format(format) // Use dayjs.unix() for timestamps in seconds
  }
  return null // Return null if input is not a valid timestamp
}

export const getISOToUTCDateFromTimestamp = (timestamp) => {
  return dayjs.unix(timestamp)// Return null if input is invalid
}

export const getDefaultTime = (hours) => {
  let date = new Date()
  date.getHours() >= 11 ? date.setDate(date.getDate() + 1) : date
  date.setHours(hours, 0, 0, 0)
  const unixTimestamp = Math.floor(date.getTime() / 1000)
  return unixTimestamp
}

export const capitalizeAndRemoveUnderscore = (str) => {
  const newStr =
    str &&
    str
      .toLowerCase() // Convert the entire string to lowercase
      .replace(/_/g, ' ') // Replace underscores with spaces
      .split(' ') // Split the string into an array of words
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter of each word
      .join(' ') // Join the words back into a single string
  return newStr
}

export const setTimestamp = (timeZone) => {
  return dayjs().tz(timeZone).unix().toString()
}

export const getTimeStamp = (dateString) => {

  // If dateString is null than emmpty that value
  if (!dateString) {
    return ''
  }
  // Create a dayjs object in UTC
  const date = dayjs(dateString)

  // Get the UTC timestamp in seconds
  const utcTimestampInSeconds = date.unix().toString()

  return utcTimestampInSeconds
}

// Convert timestamp to date format (19th Sep 2024)
export const convertTimestampToDate = (timestamp) => {
  return dayjs(timestamp * 1000).format('DD MMM YYYY') // Multiply by 1000 to convert from seconds to milliseconds
}

// Convert timestamp to time format (01:11 AM)
export const convertTimestampToTime = (timestamp) => {
  return dayjs(timestamp * 1000).format('hh:mm A')
}

export function getDateWithCurrentTime(clickedDate) {
  return dayjs(clickedDate)
    .hour(23) // Set the hour to 23 (11 PM in 24-hour format)
    .minute(59) // Set the minute to 59
    .second(0) // Set the second to 0
    .millisecond(0) // Set milliseconds to 0 (optional)
    .format('YYYY-MM-DDTHH:mm') // Format as per your requirement
}
// export const convertTimestampToDate = (timestamp) => {
//   return dayjs(timestamp * 1000).format('DD MMM YYYY') // Multiply by 1000 to convert from seconds to milliseconds
// }
// export const convertTimestampToTime = (timestamp) => {
//   return dayjs(timestamp * 1000).format('hh:mm A')
// }

export const convertTimestampToDate_Time = (timestamp) => {
  return dayjs(timestamp * 1000).format('') // Multiply by 1000 to convert from seconds to milliseconds
}

// Convert timestamp to Date object
export const convertUnixToDate = (unixTimestamp) => new Date(unixTimestamp * 1000)

export const getCurrentMonthTimestamps = () => {
  // Get the current date
  const now = new Date()

  // Get the start of the month (1st day of the month, 00:00:00)
  const startTimestamp = Math.floor(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), 1, 0, 0, 0) / 1000)

  // Get the end of the month (last day of the month, 23:59:59)
  const endTimestamp = Math.floor(Date.UTC(now.getUTCFullYear(), now.getUTCMonth() + 1, 0, 23, 59, 59) / 1000)

  return { startTimestamp, endTimestamp }
}

export const getCurrentDayTimestamps = () => {
  // Get the current date in local time
  const now = new Date()

  // Get the start of the current day in local time (00:00:00)
  const startOfDayLocal = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0)

  // Get the end of the current day in local time (23:59:59)
  const endOfDayLocal = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59)

  // Convert local times to UTC timestamps (in seconds)
  const startDayTimestamp = Math.floor(startOfDayLocal.getTime() / 1000)
  const endDayTimestamp = Math.floor(endOfDayLocal.getTime() / 1000)

  return {
    startDayTimestamp,
    endDayTimestamp
  }
}

export const getDayUTCTimestampsFromLocalDate = (inputDate) => {
  // Convert the input date to a Date object
  const localDate = new Date(inputDate)

  // Calculate the offset in milliseconds for the local timezone
  const timezoneOffset = localDate.getTimezoneOffset() * 60 * 1000

  // Adjust the local date to UTC by subtracting the offset
  const utcDate = new Date(localDate.getTime() - timezoneOffset)

  // Get the start of the day in UTC (00:00:00 UTC)
  const startOfDayUTC = Math.floor(Date.UTC(utcDate.getUTCFullYear(), utcDate.getUTCMonth(), utcDate.getUTCDate(), 0, 0, 0) / 1000)

  // Get the end of the day in UTC (23:59:59 UTC)
  const endOfDayUTC = Math.floor(Date.UTC(utcDate.getUTCFullYear(), utcDate.getUTCMonth(), utcDate.getUTCDate(), 23, 59, 59) / 1000)

  return { startDayTimestamp: startOfDayUTC, endDayTimestamp: endOfDayUTC }
}

// Utility Functions
export const formatPhoneNumbertoString = (phoneNumber) => {
  return phoneNumber.replace(/\D/g, '') // Remove non-numeric characters
}

export const maskPhoneNumber = (phoneNumber) => {
  if (!phoneNumber) return ''
  const cleaned = formatPhoneNumbertoString(phoneNumber)
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
  if (match) {
    return `(${match[1]}) ${match[2]}-${match[3]}`
  }
  return phoneNumber
}

export const convertTimeToLocalTime = (timestamp) => {
  return dayjs(timestamp * 1000).format('hh:mm A')
}

export const formatTimeAgo = (timestamp) => {
  const now = new Date()
  const time = new Date(timestamp * 1000) // Convert seconds to milliseconds
  const diffInSeconds = Math.floor((now - time) / 1000)
  if (diffInSeconds < 60) {
    return `${diffInSeconds} sec ago`
  } else if (diffInSeconds < 3600) {
    const minutes = Math.floor(diffInSeconds / 60)
    return `${minutes} min ago`
  } else if (diffInSeconds < 86400) {
    const hours = Math.floor(diffInSeconds / 3600)
    return `${hours} h ago`
  } else {
    const days = Math.floor(diffInSeconds / 86400)
    return `${days} day${days > 1 ? 's' : ''} ago`
  }
}

export const generateNumberPattern = (totalCount, base) => {
  const result = []
  for (let i = 0; i < totalCount; i++) {
    result.push(i % base)
  }
  return result
}

export const getWindowDivSize = () => {
  const desktopSize = window.matchMedia('(min-width: 1200px)')?.matches
  const mobileSize = window.matchMedia('(min-width: 767px)')?.matches
  return desktopSize ? 3 : mobileSize ? 2 : 1
}

export const scrollGoToTop = () => {
  window.scrollTo({ top: 0, behavior: 'auto' })
}

export const appendImageURL = (img) => {
  if (img) {
    if (img.includes('/static/media')) {
      return img
    } else if (img.startsWith('https://s3.ap-south-1.amazonaws.com')) {
      return img
    } else {
      return `${process.env.REACT_APP_IMAGE_URL}${img}`
    }
  }
  return ''
}

export const getLocationAddress = async (latitude, longitude) => {
  try {
    const apiKey = process.env.REACT_APP_GOOGLE_MAP_API_KEY
    const url = 'https://maps.googleapis.com/maps/api/geocode/json'
    const response = await axios.get(url, {
      params: {
        latlng: `${latitude},${longitude}`,
        key: apiKey
      }
    })
    if (response.data.results.length > 0) {
      return { address: response.data.results[0].formatted_address, placeId: response?.data?.results[0]?.place_id }
    } else {
      return null
    }
  } catch (error) {
    console.error('Error fetching address:', error)
    return null
  }
}

// export const getPlaceDetailsById = async (place_id) => {
//   try {
//     const apiKey = process.env.REACT_APP_GOOGLE_MAP_API_KEY
//     const url = `https://maps.googleapis.com/maps/api/place/details/json?placeid=${place_id}&key=${apiKey}`
//     const response = await axios.get(url)
//     if (response.data?.result?.url) {
//       return response.data?.result?.url
//     } else {
//       return null
//     }
//   } catch (error) {
//     console.error('Error fetching address:', error)
//     return null
//   }
// }

export const convertTimestampToCalenderDate = (timestamp) => {
  return dayjs(timestamp * 1000).format('YYYY-MM-DD') // Multiply by 1000 to convert from seconds to milliseconds
}

export const convertTimestampToUtc_Date = (timestamp) => {
  return dayjs(timestamp * 1000).format('YYYY-MM-DD') // Multiply by 1000 to convert from seconds to milliseconds
}

export const getDayStartAndEndTimestamps = (timestamp) => {
  // Convert the Unix timestamp (in seconds) to a Day.js object
  const givenDate = dayjs.unix(timestamp)

  // Calculate the start and end of the day (UTC)
  const startOfDayTimestamp = givenDate.startOf('day').unix() // Start of day in seconds (Unix timestamp)
  const endOfDayTimestamp = givenDate.endOf('day').unix() // End of day in seconds (Unix timestamp)

  return {
    startOfDayTimestamp,
    endOfDayTimestamp
  }
}

// Convert timestamp to time format (01:11 AM)
export const convertTimestampToTimeWithoutUTC = (timestamp) => {
  return dayjs(timestamp * 1000).format('hh:mm A')
}

export const convertTimestampToDateWithoutUTC = (timestamp) => {
  return dayjs(timestamp * 1000).format('DD MMM YYYY') // Multiply by 1000 to convert from seconds to milliseconds
}

export const formatAmount = (amount) => {
  if (isNaN(amount)) {
    return amount
  }
  return `$${Number(amount).toFixed(2)}`
}

export const isDateBefore = (date, referenceDate) => (referenceDate ? date < referenceDate : false)
export const isDateAfter = (date, referenceDate) => (referenceDate ? date > referenceDate : false)


export const formatCleaningTime = (time) => {
  const [hours, minutes, seconds] = time.split(':').map(Number)

  let result = []

  if (hours > 0) result.push(`${hours}h`)
  if (minutes > 0) result.push(`${minutes}m`)
  if (seconds > 0) result.push(`${seconds}s`)

  return `${result.join(' ')}`
}

export const objectsAreEqual = (obj1, obj2) => JSON.stringify(obj1) === JSON.stringify(obj2)

export const capitalizeFirstLetter = (str) => {
  if (!str || typeof str !== 'string') return str
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export const getTimeZoneDifferenceMessage = (propertyTimeZone) => {
  const systemTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
  const now = dayjs()
  const systemOffset = now.tz(systemTimeZone).utcOffset() // in minutes
  const propertyOffset = now.tz(propertyTimeZone).utcOffset() // in minutes
  const offsetDifference = (propertyOffset - systemOffset) / 60 // in hours

  if (offsetDifference === 0) {
    return `Cleaning times are based on your system time zone (<span class="fw-600">${propertyTimeZone}</span>), which is the same as the property's time zone.`
  }

  const sign = offsetDifference > 0 ? '+' : '−'
  const absDiff = Math.abs(offsetDifference)
  return `Cleaning times are based on your system time zone (<span class="fw-600">${systemTimeZone}</span>), which is <span class="fw-600">${sign}${absDiff}</span> hour${absDiff !== 1 ? 's' : ''} ${offsetDifference > 0 ? 'ahead of' : 'behind'} the property's time.`
}